import React, { useMemo } from 'react'
import { When } from 'react-if'
import { PlayerLogoOverlay } from '@/molecules/PlayerLogoOverlay/PlayerLogoOverlay'
import { AngelPlayer, createAsset } from '@/organisms/AngelPlayer'
import { PifExplainerVideoPlayerProps } from '@/organisms/PifExplainerVideoPlayer/types'

export const PifExplainerVideoPlayer: React.FC<PifExplainerVideoPlayerProps> = ({
  pifExplainerVideoUrl,
  name,
  slug,
  logoCloudinaryPath,
}) => {
  const asset = useMemo(() => {
    return createAsset({
      url: pifExplainerVideoUrl,
      guid: `${slug}-pif-explainer-video-${pifExplainerVideoUrl}`,
      name: `Pay it Forward to ${name}`,
      slug: `pay-it-forward-${slug}`,
      videoType: 'pif-explainer',
      subtitle: `Pay it Forward to ${name}`,
      title: ``,
    })
  }, [pifExplainerVideoUrl, slug, name])

  return (
    <AngelPlayer asset={asset} className="relative" shouldSaveWatchPosition={false}>
      <When condition={logoCloudinaryPath && logoCloudinaryPath.length > 0}>
        <PlayerLogoOverlay logoCloudinaryPath={logoCloudinaryPath} name={name} slug={slug} />
      </When>
    </AngelPlayer>
  )
}

PifExplainerVideoPlayer.displayName = 'React.memo(PifExplainerVideoPlayer)'
